(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    
    
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

/* -------- Sticky PDP logic -------- */
// Cache the element and its threshold the first time
if (!this.stickyPdpInitialized) {
  this.stickyPdp = document.querySelector('.sticky-pdp');

  if (this.stickyPdp) {
    const rect = this.stickyPdp.getBoundingClientRect();
    this.stickyPdpOffsetTop = rect.top + window.pageYOffset;
    this.stickyPdpHeight = this.stickyPdp.offsetHeight;
    this.stickyPdpThreshold = this.stickyPdpOffsetTop + this.stickyPdpHeight;
  }

  this.stickyPdpActive = false;
  this.stickyPdpInitialized = true;
}

if (this.stickyPdp) {
  const shouldBeSticky = scrollTop > this.stickyPdpThreshold;

  if (shouldBeSticky !== this.stickyPdpActive) {
    this.stickyPdpActive = shouldBeSticky;

    const stickyInfo = document.querySelector('.sticky-info');
    const priceEl = document.querySelector('.price-item--sale'); // your price wrapper
    const atcTextEl = document.querySelector('.product-form__submit span');

    if (shouldBeSticky) {
      document.body.classList.add('sticky');

      /* --- Insert title + thumbnail into .sticky-info --- */
      if (stickyInfo) {
        stickyInfo.innerHTML = '';

        // Title
        const titleEl = document.querySelector('.product__title h1');
        if (titleEl) {
          const titleDiv = document.createElement('div');
          titleDiv.className = 'sticky-info__title';
          titleDiv.textContent = titleEl.textContent.trim();
          stickyInfo.appendChild(titleDiv);
        }

        // Thumbnail
        const thumbImg = document.querySelector('.thumbnail-list li img');
        if (thumbImg) {
          const imgClone = thumbImg.cloneNode(true);
          imgClone.classList.add('sticky-info__img');
          stickyInfo.insertBefore(imgClone, stickyInfo.firstChild);
        }
      }

      /* --- Add price to ATC button as a separate span, keep it in sync --- */
      if (priceEl && atcTextEl) {
        // Make sure we have a dedicated price span inside the button
        var buttonEl = atcTextEl.parentElement;
        var priceSuffixEl = buttonEl.querySelector('.sticky-atc-price');

        if (!priceSuffixEl) {
          priceSuffixEl = document.createElement('span');
          priceSuffixEl.className = 'sticky-atc-price';
          buttonEl.appendChild(priceSuffixEl);
        }

        // Function that always uses current DOM elements
        var updatePriceSuffix = function () {
          var currentPriceEl = document.querySelector('.price-item--sale');
          var currentPriceSpan = buttonEl.querySelector('.sticky-atc-price');
          if (!currentPriceEl || !currentPriceSpan) return;

          var priceText = currentPriceEl.textContent.trim();
          currentPriceSpan.textContent = ' - ' + priceText;
        };

        // Initial set when sticky first kicks in
        updatePriceSuffix();

        // Watch for price changes and DOM swaps in the price container
        if (!this.priceObserver) {
          var priceContainer = priceEl.closest('.price__container') || priceEl.parentNode;
          var observer = new MutationObserver(updatePriceSuffix);
          observer.observe(priceContainer, {
            childList: true,
            subtree: true,
            characterData: true
          });
          this.priceObserver = observer;
        }
      }

    } else {
      /* --- Sticky OFF --- */
      document.body.classList.remove('sticky');

      if (stickyInfo) stickyInfo.innerHTML = '';

      // Remove the extra price span from the button
      const currentButtonSpan = document.querySelector('.product-form__submit span');
      if (currentButtonSpan && currentButtonSpan.parentElement) {
        const priceSuffixEl = currentButtonSpan.parentElement.querySelector('.sticky-atc-price');
        if (priceSuffixEl) {
          priceSuffixEl.remove();
        }
      }

      // Stop watching price changes
      if (this.priceObserver) {
        this.priceObserver.disconnect();
        this.priceObserver = null;
      }
    }
  }
}



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Re-apply the sticky price suffix when a variant is changed
document.addEventListener('change', function (event) {
  // Only care about changes inside <variant-radios>
  if (!event.target.closest || !event.target.closest('variant-radios')) return;

  // Only if sticky bar is active
  if (!document.body.classList.contains('sticky')) return;

  // Let Shopify finish updating the price/button first
  setTimeout(function () {
    var priceEl = document.querySelector('.price-item--sale');
    var buttonEl = document.querySelector('.product-form__submit');

    if (!priceEl || !buttonEl) return;

    // Ensure we have the extra price span
    var priceSuffixEl = buttonEl.querySelector('.sticky-atc-price');
    if (!priceSuffixEl) {
      priceSuffixEl = document.createElement('span');
      priceSuffixEl.className = 'sticky-atc-price';
      buttonEl.appendChild(priceSuffixEl);
    }

    // Update suffix to match the new variant price
    var priceText = priceEl.textContent.trim();
    priceSuffixEl.textContent = ' - ' + priceText;
  }, 350);
});


  } catch(e) { console.error(e); }
})();
})();
